<script>
  import ArticleSearch from 'src/pc/pages/ArticleSearch'
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import SubPageLayout from '../layouts/SubPageLayout'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  export default {
    extends: ArticleSearch,
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      PostContainer,
      DropDown
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .article_search .tag {
    display: block;
    text-align: center;
    border-bottom: 1px solid #000;
    padding-top: 20px;
    padding-bottom: 35px;
  }
  .article_search .tag p {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  .article_search .tag p.ctry_kr {
    font-family: 'Roboto Slab' ,'SUIT Variable';
    font-size: 27px;
    font-weight: 800;
  }
  .article_search .no_result img {
    padding: 30px 0;
  }
  .article_search .no_result p {
    font-size: 1.2em;
  }
</style>
